import React from 'react';
import { Colors } from '../../constants';

const TimezoneIcon = ({ color = `#${Colors.black}`, width = '22', height = '22' }) => {
  return(
    <svg width={width} height={height} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M11 21.2595C16.5228 21.2595 21 16.7824 21 11.2595C21 5.73667 16.5228 1.25952 11 1.25952C5.47715 1.25952 1 5.73667 1 11.2595C1 16.7824 5.47715 21.2595 11 21.2595Z" 
        stroke={color}
        strokeLinecap="round" 
        strokeLinejoin="round"/>
      <path 
        d="M1 11.2595H21" 
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"/>
      <path 
        d="M11 1.25952C13.5013 3.99787 14.9228 7.55156 15 11.2595C14.9228 14.9675 13.5013 18.5212 11 21.2595C8.49872 18.5212 7.07725 14.9675 7 11.2595C7.07725 7.55156 8.49872 3.99787 11 1.25952V1.25952Z" 
        stroke={color} 
        strokeLinecap="round" 
        strokeLinejoin="round"/>
      </svg>
  );
};

export default TimezoneIcon;